import { gsap, ScrollTrigger } from "@gsap";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Partners
 * Slug: partners
 */

document.addEventListener("DOMContentLoaded", function () {
	gsap.registerPlugin(ScrollTrigger);
	const layouts = document.querySelectorAll(".flex-layout.partners-layout");

	layouts.forEach((layout) => {
		return new Swiper(layout.querySelector(".swiper-container"), {
			spaceBetween: 16,
			on: {
				afterInit: (self) => {
					gsap.from(self.slides, {
						y: -20,
						autoAlpha: 0,
						duration: 0.2,
						stagger: 0.1,
						scrollTrigger: {
							trigger: self.el,
							start: "top center+=25%",
							markers: false,
						},
					});
				},
			},
			breakpoints: {
				0: {
					slidesPerView: 1.25,
				},
				993: {
					slidesPerView: 3,
				},
			},
		});
	});
});
